import { User } from "@/types";

import { axios } from "../axios.instance";

export type VerifyResetPasswordRequest = {
  email: User["email"];
  code: string;
};

export type VerifyResetPasswordResponse = object;

export const verifyResetPassword = async (body: VerifyResetPasswordRequest): Promise<VerifyResetPasswordResponse> => {
  const { data } = await axios.post("auth/verify-reset-password", body);

  return data;
};
